/* ============================================================
   BLACKLIST CART BEHAVIOUR - additive only. Does NOT modify cart
   markup, the checkout button, the cart form, or Magic Checkout.
   - minus button at min quantity → reuse Horizon's own Remove
     (so qty 0 removes instantly, no "minimum 1" dead-click)
   - after a remove: sync count badges + auto-close drawer when empty
   Horizon already removes on qty input = 0 and via its Remove button;
   we only fill the minus-at-min gap and add the auto-close nicety.
   ============================================================ */
(function () {
  'use strict';

  /* ----- KILL THE SIDE CART -----
     Any attempt to open the cart drawer (the navbar icon, add-to-cart auto-open,
     quick-view, or any custom trigger) goes to the /cart page instead. We override
     the cart-drawer-component's open()/showDialog() so every open path redirects.
     The component still EXISTS (count badge + Magic Checkout untouched) - it just
     never shows as a slide-out. */
  (function killSideCart() {
    function patch() {
      var C = (window.customElements && customElements.get) ? customElements.get('cart-drawer-component') : null;
      if (!C || !C.prototype || C.prototype.__blSideCartKilled) return;
      C.prototype.__blSideCartKilled = true;
      var go = function () { window.location.href = '/cart'; };
      C.prototype.showDialog = go;
      C.prototype.open = go;
    }
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer-component').then(patch).catch(function () {});
    }
    patch();
  })();

  document.addEventListener('click', function (e) {
    // 1) minus at minimum quantity → trigger Horizon's Remove for that line
    var minus = e.target.closest('button[name="minus"], .quantity-minus');
    if (minus) {
      var row = minus.closest('[data-key]'); // cart line row (not present on PDP)
      if (row) {
        var input = row.querySelector('input[type="number"]');
        if (input) {
          var val = parseInt(input.value, 10);
          var min = parseInt(input.getAttribute('data-min') || input.getAttribute('min') || '1', 10);
          if (!isNaN(val) && val <= min) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var rm = row.querySelector('.cart-items__remove');
            if (rm && !rm.hidden) rm.click();
            scheduleEmptyCheck();
            return;
          }
        }
      }
    }
    // 2) any native Remove click → sync + maybe auto-close
    if (e.target.closest('.cart-items__remove')) scheduleEmptyCheck();
  }, true); // capture so we beat Horizon's own minus handler

  function scheduleEmptyCheck() {
    setTimeout(function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('[data-cart-count]').forEach(function (b) {
            b.textContent = c.item_count;
            b.setAttribute('data-cart-count', c.item_count);
          });
          if (c.item_count === 0) {
            setTimeout(closeCartDrawer, 2000); // auto-close ~2s after empty
          }
        })
        .catch(function () {});
    }, 400);
  }

  function closeCartDrawer() {
    try {
      var comp = document.querySelector('cart-drawer-component');
      if (comp && typeof comp.close === 'function') { comp.close(); return; }
      var dlg = document.querySelector('dialog.cart-drawer__dialog[open]');
      if (dlg && typeof dlg.close === 'function') dlg.close();
    } catch (e) {}
  }

  /* Mobile bottom-sheet close: a circular button floating centered just ABOVE the
     sheet. Injected as a DIRECT CHILD of <cart-drawer-component> (sibling of the
     re-rendered dialog inner) so cart re-renders never wipe it. CSS hides it on
     desktop and positions it on mobile. */
  function injectSheetClose() {
    var comp = document.querySelector('cart-drawer-component');
    if (!comp || comp.querySelector('.bl-cart-sheetclose')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bl-cart-sheetclose';
    btn.setAttribute('aria-label', 'Close cart');
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6 6 18"/></svg>';
    btn.addEventListener('click', closeCartDrawer);
    comp.appendChild(btn);
  }
  document.addEventListener('DOMContentLoaded', injectSheetClose);
  if (document.readyState !== 'loading') injectSheetClose();

  /* ----- Cart drawer rescue (critical) -----
     Each custom-shell section's JS hides the stock Horizon header via inline
     style.setProperty('display','none','important') on .shopify-section-group-header-group.
     But that element CONTAINS <cart-drawer-component> (the cart <dialog>), so the cart
     drawer gets killed site-wide. Inline !important beats any stylesheet, so we counter it
     with inline style too: keep the header SECTION rendered but collapsed to 0 height (no
     visible bar), so the cart <dialog> (position:fixed) still opens full-size. Re-apply on
     any re-hide via a MutationObserver. */
  function rescueCartDrawerHeader() {
    var hg = document.getElementById('header-group');
    var cdc = document.querySelector('cart-drawer-component');
    if (!hg || !cdc) return;
    Array.prototype.forEach.call(hg.children, function (child) {
      if (child.contains(cdc)) {
        if (child.style.display === 'none' || getComputedStyle(child).display === 'none') {
          child.style.setProperty('display', 'block', 'important');
        }
        child.style.setProperty('height', '0', 'important');
        child.style.setProperty('overflow', 'hidden', 'important');
      }
    });
    var hc = cdc.closest('header-component');
    if (hc) {
      hc.style.setProperty('height', '0', 'important');
      hc.style.setProperty('overflow', 'hidden', 'important');
      hc.style.setProperty('display', 'block', 'important');
    }
  }
  document.addEventListener('DOMContentLoaded', rescueCartDrawerHeader);
  if (document.readyState !== 'loading') rescueCartDrawerHeader();
  window.addEventListener('load', rescueCartDrawerHeader);
  setTimeout(rescueCartDrawerHeader, 200);
  setTimeout(rescueCartDrawerHeader, 700);
  try {
    var hgEl = document.getElementById('header-group');
    if (hgEl && window.MutationObserver) {
      var rt;
      var obs = new MutationObserver(function () { clearTimeout(rt); rt = setTimeout(rescueCartDrawerHeader, 50); });
      obs.observe(hgEl, { attributes: true, attributeFilter: ['style', 'class'], subtree: true });
    }
  } catch (e) {}
})();
